import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Icon, Form, Divider, List, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";
import IkarusRateCell from "../../../components/rates/ikarusRateCell"
import GeneralRateCell from "../../../components/rates/generalRateCell"
import StateRateCell from "../../../components/rates/stateRateCell"
import ChangeStateRateModal from "../../../components/rates/changeStateRateModal"

//Actions
import { initialStateIkarusRate } from "../../../redux/actions/rates/ikarusRates/fetchIkarusRate";
import { deleteIkarusRate } from "../../../redux/actions/rates/ikarusRates/deleteIkarusRate";
import { fetchIkarusRateListCustom, initialStateIkarusRateListCustom } from "../../../redux/slices/custom/rates/ikarusRate/customIkarusRateList.slice";

// Resources
import { scrollToTop } from "../../resources/utils";

export default function IkarusRateList() {
  const { t } = useTranslation();
  let actualDate = new Date();
  let currentYear = actualDate.getFullYear();
  let yacht = "";
  let agency = "";
  let days = "all";
  let state = 1;

  const ikarusRateFilters = JSON.parse(localStorage.getItem("ikarusRateFilters"));
  if (ikarusRateFilters) {
    currentYear = ikarusRateFilters.year;
    yacht = ikarusRateFilters.yacht;
    agency = ikarusRateFilters.agency;
    days = ikarusRateFilters.days;
    state = ikarusRateFilters.state;

  }

  const { register, handleSubmit, errors, getValues } = useForm();

  const ikarusRateStateCustom = useSelector((state) => state.customIkarusRateList);
  const ikarusRateState = useSelector((state) => state.ikarusRateReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchIkarusRateListCustom({ year: currentYear, yacht_id: yacht, agency_id: agency, days: days, state: state }, ""));
    scrollToTop();
    return () => {
      dispatch(initialStateIkarusRateListCustom());
      dispatch(initialStateIkarusRate());
    };
  }, []);

  if (ikarusRateStateCustom.fetching || ikarusRateState.fetching) {
    return <Loader active inline />;
  }

  if (ikarusRateState.message === "resource deleted successfully") {
    dispatch(fetchIkarusRateListCustom({ year: getValues("year"), yacht_id: getValues("yacht_id"), agency_id: getValues("agency_id"), days: getValues("days"), state: getValues("state") }, ""));
    dispatch(initialStateIkarusRate());
  }

  if (ikarusRateState.message === "resource updated successfully") {
    dispatch(fetchIkarusRateListCustom({ year: getValues("year"), yacht_id: getValues("yacht_id"), agency_id: getValues("agency_id"), days: getValues("days"), state: getValues("state") }, ""));
    dispatch(initialStateIkarusRate());
  }

  const onSubmit = (data) => {
    let ikarusRateFilters = {
      year: getValues("year"),
      yacht: getValues("yacht_id"),
      agency: getValues("agency_id"),
      days: getValues("days"),
      state: getValues("state")
    };
    localStorage.setItem("ikarusRateFilters", JSON.stringify(ikarusRateFilters));
    dispatch(fetchIkarusRateListCustom(data, ""));
  };

  const handleDeleteIkarusRate = (ikarusRate_id) => {
    dispatch(deleteIkarusRate(ikarusRate_id));
  };

  return (
    <>
      {ikarusRateState.error ? (
        <Message negative content={t(ikarusRateState.error)} />
      ) : (
        ""
      )}
      <HeaderCatalog title={t("ikarusRate_tag")} message={ikarusRateStateCustom.message} to="/ikarusRates/ikarusRates_new" />
      <Divider />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("general_year")}</label>
            <select name="year" defaultValue={currentYear} aria-expanded="true" ref={register}>
              {ikarusRateStateCustom.years.map((year, index) => (
                <option key={index} value={year.year}>{year.year}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field required>
            <label>{t("general_yacht")}</label>
            <select name="yacht_id" defaultValue={yacht} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {ikarusRateStateCustom.yachts.map((yacht) => (
                <option key={yacht.id} value={yacht.id}>{yacht.name}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("contract_agency")}</label>
            <select name="agency_id" defaultValue={agency} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {ikarusRateStateCustom.agencies.map((agency) => (
                <option key={agency.id} value={agency.id}>{agency.name}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("general_days")}</label>
            <select name="days" defaultValue={days} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              {ikarusRateStateCustom.days.map((day, index) => (
                <option key={index} value={day.number_days}>{t(day.number_days)}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field>
            <label>{t("charter_state")}</label>
            <select name="state" defaultValue={state} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              <option value={1}>{t("active_tag")}</option>
              <option value={0}>{t("inactive_tag")}</option>
            </select>
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <Button type="submit" loading={ikarusRateStateCustom.fetching ? true : false} color="green"><Icon name='search' />{t("search_button")}</Button>
          </Form.Field>
        </Form.Group>
      </Form>
      {ikarusRateStateCustom.ikarusRates !== undefined ? (
        <Table color="blue">
          <Table.Body>
            {ikarusRateStateCustom.ikarusRates.map((ikarusRate) => (
              <>
                <Table.Row>
                  <Table.Cell colSpan='8'>
                    <div className="flex justify-between">
                      <div className=" flex flex-col p-2 ">
                        <h1 className="text-[18px]">{ikarusRate.yacht}</h1>
                        <p className="font-semibold text-[15px] mt-[-13px]">{t("general_days")}: {ikarusRate.days}</p>
                        <p className="font-semibold text-[15px] mt-[-13px]">{t("contract_agency")}: {ikarusRate.agency_name}</p>
                        <StateRateCell activation_date={ikarusRate.activation_date} inactivation_date={ikarusRate.inactivation_date} reason_deactivation={ikarusRate.reason_deactivation} />
                      </div>
                      <div className=" flex items-center pr-5">
                        <List size="large">
                          <List.Item>
                            <List.Icon color='red' name={ikarusRate.airplane_ticket === 1 ? 'plane' : 'dont'} />
                            <List.Content>
                              <List.Description>{ikarusRate.airplane_ticket === 1 ? t("general_priceInclude") : t("general_priceNotInclude")} </List.Description>
                            </List.Content>
                          </List.Item>
                        </List>
                      </div>
                    </div>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell>{t("general_year")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("general_cabin")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("range1")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("range2")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">{t("range3")}</Table.HeaderCell>
                  <Table.HeaderCell className="pl-10">{t("charter")}</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
                <Table.Row key={ikarusRate.id} className='no-row-borders'>
                  <Table.Cell collapsing><ActiveIcon active={ikarusRate.active} /></Table.Cell>
                  <Table.Cell>{ikarusRate.year}</Table.Cell>
                  <Table.Cell>
                    {ikarusRate.cabins !== null ? (
                      <Link to={`/ikarusRates/${ikarusRate.id}/cabins`}>{ikarusRate.cabins}</Link>
                    ) : (
                      <Link to={`/ikarusRates/${ikarusRate.id}/cabins`}><Button circular color='blue' icon='add' size="mini" /></Link>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <IkarusRateCell
                      from={ikarusRate.range1_number_passenger_from}
                      to={ikarusRate.range1_number_passenger_to}
                      charter_client={ikarusRate.range1_charter_client}
                      charter_operator={ikarusRate.range1_charter_operator}
                      double_client={ikarusRate.range1_double_client}
                      double_operator={ikarusRate.range1_double_operator}
                      single_client={ikarusRate.range1_single_client}
                      single_operator={ikarusRate.range1_single_operator}
                      ticket={ikarusRate.airplane_ticket} />
                  </Table.Cell>
                  <Table.Cell>
                    <IkarusRateCell
                      from={ikarusRate.range2_number_passenger_from}
                      to={ikarusRate.range2_number_passenger_to}
                      charter_client={ikarusRate.range2_charter_client}
                      charter_operator={ikarusRate.range2_charter_operator}
                      double_client={ikarusRate.range2_double_client}
                      double_operator={ikarusRate.range2_double_operator}
                      single_client={ikarusRate.range2_single_client}
                      single_operator={ikarusRate.range2_single_operator}
                      ticket={ikarusRate.airplane_ticket} />
                  </Table.Cell>
                  <Table.Cell>
                    <IkarusRateCell
                      from={ikarusRate.range3_number_passenger_from}
                      to={ikarusRate.range3_number_passenger_to}
                      charter_client={ikarusRate.range3_charter_client}
                      charter_operator={ikarusRate.range3_charter_operator}
                      double_client={ikarusRate.range3_double_client}
                      double_operator={ikarusRate.range3_double_operator}
                      single_client={ikarusRate.range3_single_client}
                      single_operator={ikarusRate.range3_single_operator}
                      ticket={ikarusRate.airplane_ticket} />
                  </Table.Cell>
                  <Table.Cell><GeneralRateCell client={ikarusRate.charter_client} operator={ikarusRate.charter_operator} ticket={ikarusRate.airplane_ticket} /></Table.Cell>
                  <Table.Cell collapsing>
                    {ikarusRate.active != false ? (
                      <ChangeStateRateModal stateRate={ikarusRate} stateError={ikarusRateState.error} typeRate="IkarusRate" />
                    ) : (
                      null
                    )}
                    {(!ikarusRate.active && !ikarusRate.reason_deactivation) && (
                      <>
                        <Link to={`/ikarusRates/${ikarusRate.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                        <Modal
                          closeOnDimmerClick={false}
                          trigger={
                            <Button circular color='red' icon='trash alternate' />
                          }
                          content={t("general_delete")}
                          actions={[
                            t("canceled_button"),
                            {
                              key: "eliminar",
                              content: t("delete_button"),
                              className: "delete_button icon_color",
                              onClick: () => handleDeleteIkarusRate(ikarusRate.id),
                            },
                          ]}
                          size="tiny"
                        />
                      </>)}
                  </Table.Cell>
                </Table.Row>
              </>
            ))}
          </Table.Body>
        </Table>
      ) : (
        ""
      )}
    </>
  );
}